import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import LanguageStrings from '../../../i18n/locales'

export const Ztag = z.object({
  name: z.string()
})
export const ZDeviceList = z.object({
  name: z.string(),
  device_type: z.string(),
  asset_model_name: z.string(),
  communication_status: z.string(),
  hierarchy: z.string()
})
export const ZData = z.object({
  total_count: z.number(),
  assets: ZDeviceList.array()
})
export const ZApiResponse = z.object({
  http_status: z.any(),
  data: z.optional(ZData),
  error: z.boolean(),
  error_message: z.optional(z.string())
})
export type DeviceList = z.infer<typeof ZDeviceList>
export type Tag = z.infer<typeof Ztag>

export const getSortField: any = (sortfield: string): string => {
  if (sortfield === 'serial_number') {
    sortfield = 'serialNumber'
  } else if (sortfield === 'install_date') {
    sortfield = 'installDate'
  } else if (sortfield === 'removal_date') {
    sortfield = 'removalDate'
  } else if (sortfield === 'state') {
    sortfield = 'lifecycleDetails.stateDefinition'
  }
  return sortfield
}

export async function getDeviceList (
  siteId: string,
  assetTypeId: string,
  PageNumber: number,
  PageItems: number,
  searchKey: string,
  SortParams: string,
  parentAssetId: string,
  onSuccess: (deviceList: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any,
  sortField?: string
): Promise<void> {
  const DeviceManagementStrings = LanguageStrings().DeviceManagementCollectionStrings.TableComponent
  const Sorting = (sortField !== '' && sortField != null) ? `${sortField},${SortParams}` : 'installDate,DESC'
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const url = `/assetrest/api/v2/udp/tiq/assets?siteId=${siteId}&assetTypeId=${assetTypeId}&page=${PageNumber - 1}&size=${PageItems}&search=${searchKey}&parentAssetId=${parentAssetId}&sort=${Sorting}`
  // &sortBy=${sortFieldVal}`

  interceptedAxios.get(url, { timeout: 15000 })
    .then((response) => {
      const parseResponse = response.data
      // istanbul ignore else
      if (parseResponse.error === false) {
        // istanbul ignore else
        if (parseResponse.data !== null && parseResponse.data !== undefined) {
          onSuccess(parseResponse.data, parseResponse.http_status)
        } else {
          onFailure(parseResponse.error, parseResponse.http_status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore next
      if (error.response !== undefined) {
        onFailure((error.response.data !== undefined || error.response.data !== null) ? error.response.data.error_message : DeviceManagementStrings.NetworkError, error.response.status)
      } else {
        onFailure(DeviceManagementStrings.NetworkError, 404)
      }
    })
}
